// Flare error tracking
import {flare} from "@flareapp/flare-client";

// load generic scripts
import './scripts/polyfills';
import './scripts/manage-locale-selection';
import './scripts/lazy-load-bg-images';
import './scripts/mobile-navigation';

// load Vue data
import {flareVue} from "@flareapp/flare-vue";
import VueTouchEvents from 'vue2-touch-events';
import VueVisibility from 'vue-observe-visibility';
import VueSocialSharing from 'vue-social-sharing';
import Vue from 'vue';

Vue.use(flareVue);
Vue.use(VueVisibility);
Vue.use(VueTouchEvents);
Vue.use(VueSocialSharing);

let appWrap = document.querySelector('.render-vue');

if (appWrap) {

    // for WYSIWYG elements, make links target="_blank"
    appWrap.querySelectorAll('.wysiwyg-block a')
        .forEach(el => {
            if (el.host === window.location.host) return;
            el.target = '_blank';
        });

    new Vue({
        components: {
            Gallery: () => import(/* webpackChunkName: "gallery" */ './components/Gallery'),
            SocialSharing: () => import(/* webpackChunkName: "social" */ './components/SocialSharing'),
            Subscribe: () => import(/* webpackChunkName: "subscribe" */ './components/Subscribe')
        }
    }).$mount(appWrap);
}
